export const findSelectOption = (options, value) => {
  if (value == null || value === "" || !Array.isArray(options) || !options.length) {
    return null;
  }
  return options.find((option) => String(option.value) === String(value)) ?? null;
};

export const createSelectOption = (value, label, extra = {}) => {
  if (value == null || value === "" || !label) return null;
  return { value, label, ...extra };
};

export const seedSelectOptions = (value, label, extra = {}) => {
  const option = createSelectOption(value, label, extra);
  return option ? [option] : [];
};

export const resolveOrgUid = (data) =>
  data?.orgUid ?? data?.orgUId ?? data?.orgId ?? null;
